import axios from 'axios';
import { useEffect } from 'react'
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { getCookie, isObjectEmpty } from "../utils/utils";
import { user, api } from "../services/config";

const RequireAuth = ({ allowedRoles, projectLessRoute, profileState, setProfileState }) => {
    const { profile, authenticated, projectRole, loaded } = profileState;
    const projectId = projectRole?.projectId;
    const role = projectRole?.role;
    const navigate = useNavigate();

    const getRole = async (id, projectName) => {
        try {
            if (projectId !== id) {
                const projectRole = { projectId: id, projectName: projectName, role: 0 };
                setProfileState((state) => ({ ...state, projectRole }));
                localStorage.setItem('projectRole', JSON.stringify(projectRole))
            }
            navigate("/", { replace: true });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        const getProfile = async () => {
            try {
                setProfileState((state) => ({ ...state, loading: true }));
                const { data } = await axios.get(user.profile);
                setProfileState((state) => ({
                    ...state,
                    loading: false,
                    loaded: true,
                    authenticated: true,
                    profile: data,
                }));
            } catch (error) {
                setProfileState({ loading: false, loaded: true, error: error.response });
            }
        };

        if (isObjectEmpty(profile))
            getProfile()
    }, [profile, setProfileState])

    return (
        !!loaded && (!authenticated
            ? <RedirectComponent />
            : (role == null)
                ? (projectLessRoute ? <Outlet context={{ getRole, profileState, setProfileState }} /> : <Navigate to="/projects" />)
                : allowedRoles && allowedRoles.includes(role)
                    ? <Outlet context={{ getRole, profileState, setProfileState }} />
                    : <Navigate to="/unauthorized" />)
    );
}

const RedirectComponent = () => {
    const csrftoken = getCookie('csrftoken')

    async function fetchRedirectLink() {
        await axios.post(user.login, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken
            }
        })
            .then(res => {
                window.location.replace(res.data.redirect)
            })
            .catch(
                function (error) {
                    return Promise.reject(error)
                }
            )
    }
    fetchRedirectLink()

    return <div className='mt-5 text-center'>Redirection vers la page de connexion </div>
}

export default RequireAuth;